import React, { useEffect, useState } from "react";
import ProjectSubHeader from "../components/ProjectSubHeader";
import { ErrorMessage, Formik } from "formik";
import { MailSettingSchema } from "../../common/Validation";
import Spin from "../../common/Spin";
import { API, fileUpload, get } from "../../../config";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

const MailSettings = () => {
  const [mailSettingData, setMailSettingData] = useState();
  const [trusteeData, setTrusteeData] = useState();
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const projectId = params?.project_id;

  // Fetching the Subcontractor Details
  useEffect(() => {
    async function fetchData() {
      try {
        // await getUsers();
        setLoading(true);
        const { data } = await get(`${API.MAIL_SETTINGS}/${projectId}`);
        setLoading(false);
        setTrusteeData(data?.trustee);
        setMailSettingData(data?.data);
      } catch (e) {
        setLoading(false);
        setMailSettingData(null);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Edit Subcontractor Function
  const handleFormSubmit = async (value) => {
    const formData = new FormData();

    formData.append("builder_project_id", projectId);
    formData.append("trustee_email", value?.trustee_email ? 1 : 0);
    formData.append(
      "representative_email",
      value?.representative_email ? 1 : 0
    );

    formData.append(
      "internal_contact_email",
      value?.internal_contact_email ? 1 : 0
    );

    formData.append(
      "other_email",
      value?.other_email ? 1 : 0
    );

    formData.append("email", value?.email ? value?.email : "");
    // formData.append("_method", "put");
    try {
      setLoading(true);
      const { data } = await fileUpload(`${API.MAIL_SETTINGS}`, formData);
      setLoading(false);
      if (data) {
        toast.success(data?.message);
      }
      return data?.data;
    } catch (error) {
      setLoading(false);
      if (error?.response?.data?.errors) {
        Object.keys(error?.response?.data?.errors).forEach((key) => {
          toast.error(error?.response?.data?.errors[key][0]);
        });
        setLoading(false);
      } else {
        toast.error(error?.message);
        setLoading(false);
      }
    }
  };
  return (
    <div className="cms-page">
      <div className="page-content-block">
        <div className="full-content-block">
          <ProjectSubHeader title={"Email Settings"} />
          <div className="content-details mail-contents">
            <section>
              <Formik
                initialValues={{
                  email: mailSettingData?.email ? mailSettingData?.email : "",
                  representative_email: mailSettingData?.representative_email
                    ? true
                    : false,
                  trustee_email: mailSettingData?.trustee_email ? true : false,
                  internal_contact_email:
                    mailSettingData?.internal_contact_email ? true : false,
                  other_email: mailSettingData?.other_email ? true : false,
                }}
                enableReinitialize
                onSubmit={handleFormSubmit}
                validateOnBlur={true}
                validateOnChange={true}
                validationSchema={MailSettingSchema}
              >
                {({
                  values,
                  setErrors,
                  errors,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                }) => {
                  return (
                    <>
                      {loading && <Spin />}
                      <form
                        onSubmit={handleSubmit}
                        noValidate
                        className="entry-section contractor-form"
                      >
                        <div className="entry-card full-card">
                          <h3>
                            Automatic emails will be cc’d to these selected
                            recipients
                          </h3>
                          <div className="form-box">
                            <div className="form-group full-width builder-firm">
                              <label className="form-lable email-checkbox-label">
                                <input
                                  type="checkbox"
                                  name="trustee_email"
                                  checked={values?.trustee_email ? true : false}
                                  onBlur={handleBlur}
                                  onClick={() => {
                                    setFieldValue(
                                      "trustee_email",
                                      !values?.trustee_email
                                    );
                                  }}
                                  autoComplete="off"
                                  onKeyPress={(e) => {
                                    e.which === 13 && e.preventDefault();
                                  }}
                                  style={{ width: "auto" }}
                                />{" "}
                                Trustee Email {trusteeData?.email ? `(${trusteeData?.email})` : ""}
                              </label>
                            </div>
                            <div className="form-group full-width builder-firm">
                              <label className="form-lable email-checkbox-label">
                                <input
                                  type="checkbox"
                                  name="representative_email"
                                  checked={
                                    values?.representative_email ? true : false
                                  }
                                  onBlur={handleBlur}
                                  onClick={() => {
                                    setFieldValue(
                                      "representative_email",
                                      !values?.representative_email
                                    );
                                  }}
                                  autoComplete="off"
                                  onKeyPress={(e) => {
                                    e.which === 13 && e.preventDefault();
                                  }}
                                  style={{ width: "auto" }}
                                />{" "}
                                Representative Email
                              </label>
                            </div>
                            <div className="form-group full-width builder-firm">
                              <label className="form-lable email-checkbox-label">
                                <input
                                  type="checkbox"
                                  name="internal_contact_email"
                                  checked={
                                    values?.internal_contact_email
                                      ? true
                                      : false
                                  }
                                  onBlur={handleBlur}
                                  onClick={() => {
                                    setFieldValue(
                                      "internal_contact_email",
                                      !values?.internal_contact_email
                                    );
                                  }}
                                  autoComplete="off"
                                  onKeyPress={(e) => {
                                    e.which === 13 && e.preventDefault();
                                  }}
                                  style={{ width: "auto" }}
                                />{" "}
                                Internal Contact Email
                              </label>
                            </div>
                            <div className="form-group half-width builder-firm">
                              <label className="form-lable email-checkbox-label">
                                <input
                                  type="checkbox"
                                  name="other_email"
                                  checked={values?.other_email ? true : false}
                                  onBlur={handleBlur}
                                  onClick={() => {
                                    setFieldValue(
                                      "other_email",
                                      !values?.other_email
                                    );
                                  }}
                                  autoComplete="off"
                                  onKeyPress={(e) => {
                                    e.which === 13 && e.preventDefault();
                                  }}
                                  style={{ width: "auto" }}
                                />{" "}
                                Other Email
                              </label>
                              <input
                                type="text"
                                name="email"
                                value={values?.email ? values?.email : ""}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                autoComplete="off"
                                onKeyPress={(e) => {
                                  e.which === 13 && e.preventDefault();
                                }}
                              />
                              <span
                                className="text-danger"
                                style={{ color: "red", fontSize: "20px" }}
                              >
                                <ErrorMessage name="email" />
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="action-box">
                          <button type="submit">Save</button>
                        </div>
                      </form>
                    </>
                  );
                }}
              </Formik>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MailSettings;
